import type { QdsOption } from '../../types/index';

/** Plain-text option content shared by inline and input-owned listboxes. */
export function createListboxOption(option: QdsOption): HTMLButtonElement {
  const button = document.createElement('button'); button.type = 'button'; button.dataset.choice = option.value;
  button.textContent = option.label; button.setAttribute('part', 'option'); button.setAttribute('aria-label', option.label);
  if (option.description) {
    const description = document.createElement('span'); description.className = 'option-description'; description.textContent = option.description;
    button.append(description); button.setAttribute('aria-description', option.description);
  }
  return button;
}

/** Preserve source order and contiguous named groups without interpreting HTML. */
export function renderGroupedOptions(container: HTMLElement, options: readonly QdsOption[], createOption: (option: QdsOption) => HTMLElement): void {
  const fragment = document.createDocumentFragment(); let group: HTMLElement | undefined, groupName = '';
  for (const option of options) {
    const name = option.group?.trim();
    if (name) {
      if (!group || groupName !== name) {
        group = document.createElement('div'); group.setAttribute('role', 'group'); group.setAttribute('part', 'group'); group.setAttribute('aria-label', name);
        const label = document.createElement('div'); label.setAttribute('part', 'group-label'); label.setAttribute('aria-hidden', 'true'); label.textContent = name; group.append(label); fragment.append(group);
        groupName = name;
      }
      group.append(createOption(option));
    } else { group = undefined; groupName = ''; fragment.append(createOption(option)); }
  }
  container.replaceChildren(fragment);
}
